import axios from "axios";
import { MasterDataURL } from "../../../../config/UrlEndPoint";

export const URL = `${MasterDataURL}project`;

// Get Project All For use Combobox data
export function getProjectAll() {
  return axios.get(URL);
}

export function getProjectAllNotFiltered() {
  return axios.get(`${URL}/not_filtered`);
}

// Get Project All For use Combobox data
export function getProjectAllCompany() {
  return axios.get(`${URL}/allcompany`);
}

// //Get By ID
export function getProjectById(projectId) {
  return axios.get(`${URL}/${projectId}`);
}

// items => filtered/sorted result for table data
export function findProject(queryParams) {
  return axios.post(`${URL}/find`, queryParams);
}

// POST => POST: Create the project on the server
export function createProject(project) {
  return axios.post(URL, project);
}

// UPDATE => PUT: update the project on the server
export function updateProject(project) {
  return axios.put(`${URL}/${project.uuid}`, project);
}

export function deleteProject(uuid) {
  return axios.delete(`${URL}/${uuid}`);
}

export const getProjectManage = uuid => {
  return axios.get(`${URL}/manage/${uuid}`);
};

export const createProjectBenefis = payload => {
  return axios.put(`${URL}/manage/benefis/${payload.uuid}`, payload);
};

export const createProjectExpense = payload => {
  return axios.post(`${URL}/manage/expense/${payload.uuid}`, payload);
};

export const updateProjectExpense = payload => {
  return axios.put(`${URL}/manage/expense/${payload.uuid}`, payload);
};

export const deleteProjectExpense = payload => {
  return axios.delete(`${URL}/manage/expense/${payload.project_uuid}`, {
    data: { uuid: payload.uuid }
  });
};

export const uploadProjectFile = (uuid, image) => {
  return axios.post(`${URL}/manage/file/${uuid}`, image);
};

export const deleteProjectFile = payload => {
  return axios.delete(`${URL}/manage/file/${payload.uuid}`, {
    data: {
      gallery_remove: payload.gallery_remove
    }
  });
};

export function findDonationItems(uuid, queryParams) {
  return axios.post(`${URL}/manage/income/${uuid}/donation_item`, queryParams);
}

export function createProjectIncome(payload) {
  return axios.post(`${URL}/manage/income/${payload.uuid}`, payload);
}

export function findIncomeItems(uuid, queryParams) {
  return axios.post(`${URL}/manage/income/${uuid}/income_item`, queryParams);
}

export function updateProjectIncome(payload) {
  return axios.put(`${URL}/manage/income/${payload.uuid}`, payload);
}

export function recapProject(project_uuid) {
  return axios({
    url: `${URL}/recap/${project_uuid}`,
    method: "GET",
    responseType: "blob"
  });
}

export function recapProjectPublic(project_uuid) {
  return axios({
    url: `${URL}/recap-public/${project_uuid}`,
    method: "GET",
    responseType: "blob"
  });
}
